/**
 * Class-name composition. Falsy entries are dropped, the rest are joined and
 * de-duplicated, so callers can write `cx('btn', variant, isActive && 'active')`
 * without producing `"btn  undefined"` or a class repeated twice.
 *
 * Deliberately ~15 lines rather than a dependency: this is the only string
 * utility the UI kit needs.
 */
export type ClassValue = string | number | false | null | undefined;

export function cx(...parts: ClassValue[]): string {
  const seen = new Set<string>();
  for (const part of parts) {
    if (!part && part !== 0) continue;
    for (const token of String(part).split(/\s+/)) {
      if (token) seen.add(token);
    }
  }
  return [...seen].join(' ');
}
